const AlertErrorIcon = () => (
  <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M11.8202 9.05L7.12016 1.14C6.88516 0.74 6.47016 0.5 6.00016 0.5C5.53016 0.5 5.11516 0.74 4.88516 1.14L0.180156 9.05C-0.0548438 9.46 -0.0548438 9.945 0.180156 10.35C0.415156 10.755 0.835156 11 1.30016 11H10.7052C11.1752 11 11.5952 10.755 11.8252 10.35C12.0552 9.945 12.0552 9.46 11.8202 9.05ZM6.50016 9H5.50016V8H6.50016V9ZM6.50016 7H5.50016V4H6.50016V7Z"
      fill="#D9534F"
    />
  </svg>
);

export default AlertErrorIcon;
